export default __webpack_public_path__ + "static/media/received.0bb52ed9.svg";